import { Component, Input } from '@angular/core';
import { Banner } from 'src/models/banner.model';

@Component({
    selector: 'app-banner',
    templateUrl: './banner.component.html',
    styleUrl: './banner.component.scss',
    // eslint-disable-next-line @angular-eslint/prefer-standalone
    standalone: false,
})
export class BannerComponent {
    @Input() public banner?: Banner;
}
